import {initWebComponent} from "@/helpers/web-component-helper";
import {
    activateUserSessionByID,
    getUserSessionByID,
    updateSession,
    updateSessionDefault
} from "@/helpers/user-session-helper";
import {hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";

export class BookmarkUserSessionDefaultButtonComponent extends HTMLElement {
    constructor(){
        super();

        const id = this.getAttribute('data-id')

        const isDefaultActive = this.getAttribute('data-is-default-active')

        const template = document.createElement('template');

        let active = ''
        let inActive = 'd-none'
        if(isDefaultActive === '1') {
            active = 'd-none'
            inActive = ''
        }

        template.innerHTML = `<button class="btn btn-sm borderless icon-btn">
              <i class="far fa-bookmark fa-star-icon ` + active + `"></i>
              <i class="fa fa-bookmark fa-star-icon-active ` + inActive + `"></i>
            </button>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {

            const icon = this.querySelector('.d-none')

            showElementsBySelector('.fa-star-icon')
            hideElementsBySelector('.fa-star-icon-active')

            if(icon.classList.contains('fa-star-icon')) {
                updateSessionDefault(id, 'disable')
            }
            else {
                this.querySelector('.fa').classList.remove('d-none')
                this.querySelector('.far').classList.add('d-none')
                updateSessionDefault(id, 'enable')
            }
        })
    }
}
